import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../logo.png';

const Header = () => {
  const location = useLocation();
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  // Sticky hide-on-scroll logic
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  // Hamburger menu state
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 50) {
        setShowHeader(true);
      } else if (currentScrollY > lastScrollY) {
        setShowHeader(false); // scrolling down
      } else {
        setShowHeader(true); // scrolling up
      }
      setLastScrollY(currentScrollY);
  };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className={`header${showHeader ? '' : ' header-hidden'}`}>
      {/* Top Info Bar */}
      <div className="header-topbar">
        <div className="header-topbar-left">
          <span className="header-location">📍 Haware fantasia business park Navi Mubal - 400706</span>
          <span className="header-separator">|</span>
          <span className="header-email">✉️ info@tcsl.in</span>
        </div>
        <div className="header-topbar-right">
          <span className="header-hours">🕒 Mon to Sat: 8.00 am - 7.00 pm</span>
          <span className="header-separator">|</span>
          <span className="header-socials">
            <a href="#" aria-label="Facebook" className="header-social-icon">
              <img src="https://cdn-icons-png.flaticon.com/128/5968/5968764.png" alt="Facebook" style={{width: '20px', height: '20px'}} />
            </a>
            <a href="#" aria-label="Twitter" className="header-social-icon">
              <img src="https://cdn-icons-png.flaticon.com/128/5969/5969020.png" alt="Twitter" style={{width: '20px', height: '20px'}} />
            </a>
            <a href="#" aria-label="Pinterest" className="header-social-icon">
              <img src="https://cdn-icons-png.flaticon.com/128/145/145808.png" alt="Pinterest" style={{width: '20px', height: '20px'}} />
            </a>
            <a href="#" aria-label="Instagram" className="header-social-icon">
              <img src="https://cdn-icons-png.flaticon.com/128/4138/4138124.png" alt="Instagram" style={{width: '20px', height: '20px'}} />
            </a>
          </span>
        </div>
      </div>

      {/* Main Header Bar */}
      <div className="header-mainbar">
        <div className="header-mainbar-left">
          <Link to="/" className="header-logo">
            <img src={logo} alt="Company Logo" className="header-logo-img" />
          </Link>
        </div>
        {/* Hamburger menu button for mobile */}
        <button
          className={`header-hamburger${mobileMenuOpen ? ' open' : ''}`}
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMobileMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
          </button>
        <div className="header-mainbar-center">
          <nav className="header-nav">
            <ul className="header-nav-list">
              <li><Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link></li>
              <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link></li>
              <li><Link to="/services" className={isActive('/services') ? 'active' : ''}>Services</Link></li>
              <li><Link to="/work" className={isActive('/work') ? 'active' : ''}>Work</Link></li>
              <li><Link to="/blog" className={isActive('/blog') ? 'active' : ''}>Blog</Link></li>
              <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link></li>
            </ul>
          </nav>
        </div>
        <div className="header-mainbar-right">
          <div className="header-call">
            <span className="header-call-icon">📞</span>
            <div className="header-call-info">
              <span className="header-call-label">Call Anytime</span>
              <span className="header-call-number">+91 984632 9999</span>
            </div>
          </div>
          <Link to="/contact" className="header-quote-btn">Get a Quote</Link>
        </div>
      </div>
      {/* Mobile Nav Overlay */}
      <div className={`header-mobile-nav${mobileMenuOpen ? ' open' : ''}`}>
        <ul className="header-mobile-nav-list">
          <li><Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link></li>
          <li><Link to="/services" className={isActive('/services') ? 'active' : ''}>Services</Link></li>
          <li><Link to="/work" className={isActive('/work') ? 'active' : ''}>Work</Link></li>
          <li><Link to="/blog" className={isActive('/blog') ? 'active' : ''}>Blog</Link></li>
          <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link></li>
        </ul>
        <div className="header-mobile-nav-extra">
          <div className="header-call">
            <span className="header-call-icon">📞</span>
            <div className="header-call-info">
              <span className="header-call-label">Call Anytime</span>
              <span className="header-call-number">+91 984632 9999</span>
            </div>
          </div>
          <Link to="/contact" className="header-quote-btn">Get a Quote</Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 